import { FC } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SportBetSlip: FC<SvgIconProps> = (props) => (
  <SvgIcon width="100%" height="100%" viewBox="0 0 512 512" {...props}>
    <g>
      <path
        className="st0"
        d="M411.4,15c0-5.7-3.2-10.9-8.3-13.4C398-1,391.9-0.4,387.4,3l-26.1,19.4L335.1,3c-5.3-4-12.6-3.9-17.9,0
		l-26.1,19.4L264.9,3c-5.3-4-12.6-4-17.9,0l-26.1,19.4L194.8,3c-5.3-4-12.6-4-17.9,0l-26.1,19.4L124.6,3c-4.5-3.4-10.6-4-15.7-1.4
		s-8.3,7.7-8.3,13.4v481.9c0,5.7,3.2,10.9,8.3,13.4c2.1,1.1,4.4,1.6,6.8,1.6c3.2,0,6.3-1,9-3l26.1-19.4l26.1,19.4
		c5.3,4,12.6,3.9,17.9,0l26.1-19.4L247,509c5.3,4,12.6,4,17.9,0l26.1-19.4l26.1,19.4c5.3,4,12.6,4,17.9,0l26.1-19.4l26.1,19.4l0,0
		c4.1,2.9,8.9,3,8.9,3c6.5,0,12.2-4.2,14.3-10.3c0.5-1.6,0.8-3.3,0.8-4.9C411.4,486.9,411.4,19.8,411.4,15L411.4,15z M299.4,398.9
		c-2.7,15-15,26.6-30.8,30.1v9.9c0,6.9-5.6,12.5-12.5,12.5s-12.5-5.6-12.5-12.5v-10.6c-10.9-2.7-20.7-8.4-28.1-16.6
		c-4.6-5.1-4.3-13,0.9-17.7c5.1-4.6,13-4.3,17.7,0.9c5.3,5.9,13.4,9.5,22,10.1c0.8,0,1.5,0.1,2.3,0.1c9.1,0,15.5-5.4,16.4-10.6
		c1.3-7-9.1-11.4-12.4-12.6c-2.2-0.8-28.4-11.5-28.8-11.7c-0.6-0.3-1.2-0.6-1.7-0.9c-10.3-6.7-15.6-18.5-13.9-30.8
		c1.9-13.1,11.4-23.7,24.9-27.8c0.2-0.1,0.5-0.1,0.7-0.2v-10.6c0-6.9,5.6-12.5,12.5-12.5c6.9,0,12.5,5.6,12.5,12.5V310
		c13.7,3.2,23.1,10.9,23.7,11.4c5.3,4.4,6,12.3,1.6,17.6c-4.4,5.3-12.3,6-17.6,1.6l0,0c-0.3-0.3-9.3-7.3-20.1-7
		c-1.9,0.1-3.9,0.3-6,1c-5.9,1.8-7.1,5.7-7.3,7.3c-0.2,1.1-0.2,3.8,2.1,5.8c1.9,0.8,20.8,8.6,26.2,10.6
		C295.6,367.5,301.8,385.3,299.4,398.9L299.4,398.9z M336.3,257H175.7c-8.3,0-15-6.7-15-15s6.7-15,15-15h160.6c8.3,0,15,6.7,15,15
		S344.6,257,336.3,257z M336.3,196.9H175.7c-8.3,0-15-6.7-15-15s6.7-15,15-15h160.6c8.3,0,15,6.7,15,15S344.6,196.9,336.3,196.9z
		 M336.3,136.8H175.7c-8.3,0-15-6.7-15-15s6.7-15,15-15h160.6c8.3,0,15,6.7,15,15S344.6,136.8,336.3,136.8z"
      />
    </g>
  </SvgIcon>
);

export default SportBetSlip;
